// extracted by mini-css-extract-plugin
export default {"title":"CTAVideoBanner_title__y2Uak","wrapper":"CTAVideoBanner_wrapper__rWK4J"};